

export const chatLink = {
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start',
    width: '100%',
    padding: '10px'
}

export const chatDescriptionStyle = {
    color: 'white',
    wordBreak: 'break-word'
}